module.exports = __webpack_public_path__ + "static/media/HenryLogo.bb57fd6f.163a5d85.svg";